export default class NavigationDesktop {
  constructor($el) {
    this.$el = $el;
    this.$mainItems = this.$el.querySelectorAll('.main-navigation__item');
    this.$mainLinks = this.$el.querySelectorAll('.main-navigation__item-link[aria-controls]');
    this.$closeSubmenues = this.$el.querySelectorAll('.main-navigation__sub-close');

    this.onKeydownBinded = this.onKeydown.bind(this);
  }

  init() {
    this.$mainLinks.forEach(($link) => {
      $link.addEventListener('click', this.click);
    });

    this.$closeSubmenues.forEach(($link) => {
      $link.addEventListener('click', this.close);
    });

    document.body.addEventListener('keydown', this.onKeydownBinded);
  }

  deInit() {
    this.$mainLinks.forEach(($link) => {
      $link.removeEventListener('click', this.click);
    });

    this.$closeSubmenues.forEach(($link) => {
      $link.removeEventListener('click', this.close);
    });

    document.body.removeEventListener('keydown', this.onKeydownBinded);
  }

  onKeydown(event) {
    // Close menu on ESC
    if (event.keyCode === 27) {
      event.preventDefault();
      this.closeAll();
    }
  }

  closeAll = () => {
    this.$mainLinks.forEach(($link) => {
      const parentItem = $link.closest('.main-navigation__item');
      const parentSubmenu = $link.getAttribute('aria-controls');
      document.getElementById(parentSubmenu).classList.remove('open');
      parentItem.classList.remove('open');
      $link.setAttribute('aria-expanded', 'false');
    });
  }

  close = (event) => {
    const parentItem = event.target.closest('.main-navigation__item');
    const parentLink = parentItem.querySelector('.main-navigation__item-link');

    parentItem.classList.remove('open');
    const parentSubmenu = parentLink.getAttribute('aria-controls');
    document.getElementById(parentSubmenu).classList.remove('open');
    parentLink.setAttribute('aria-expanded', 'false');
  }

  click = (event) => {
    const controls = event.target.getAttribute('aria-controls');
    const expanded = event.target.getAttribute('aria-expanded');

    // close all the currently opened submenus
    this.$mainItems.forEach(($item) => {
      const itemControls = $item.querySelector('.main-navigation__item-link').getAttribute('aria-controls');
      if (itemControls && itemControls !== controls) {
        $item.classList.remove('open');
        document.getElementById(itemControls).classList.remove('open');
        $item.querySelector('.main-navigation__item-link').classList.remove('open');
        $item.querySelector('.main-navigation__item-link').setAttribute('aria-expanded', 'false');
      }
    });

    const $submenu = document.getElementById(controls);
    if ($submenu && expanded === 'false') {
      event.target.setAttribute('aria-expanded', 'true');
      $submenu.closest('.main-navigation__item').classList.add('open');
      $submenu.classList.add('open');
    } else if ($submenu && expanded === 'true') {
      event.target.setAttribute('aria-expanded', 'false');
      $submenu.closest('.main-navigation__item').classList.remove('open');
      $submenu.classList.remove('open');
    }
  }
}
